"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ArrayUtil = /** @class */ (function () {
    function ArrayUtil() {
    }
    ArrayUtil.isArray = function (array) {
        return Array.isArray(array);
    };
    ArrayUtil.isNotEmpty = function (array) {
        return ArrayUtil.isArray(array) && array.length > 0;
    };
    ArrayUtil.isEmpty = function (array) {
        return !ArrayUtil.isNotEmpty(array);
    };
    return ArrayUtil;
}());
exports.default = ArrayUtil;
//# sourceMappingURL=ArrayUtil.js.map